import gql from 'graphql-tag';

export default gql`
    query GetAllAssetLoadStatusTypes {
        getAllAssetLoadStatusTypes {
            id
            name
        }
    }
`;
